import type { IconData } from '@stacksjs/iconify-core'

export const arrowheadsDown: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.16 4.08h15.68L8 11.92z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default arrowheadsDown
